export default __webpack_public_path__ + "static/media/Telugu_am_1.b1f69c1e.mp3";